import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Dropdown, Modal } from 'react-bootstrap'
import Card from '../../../../components/Card'
import { Link, useNavigate } from 'react-router-dom'
import Moment from 'moment';
import Swal from 'sweetalert2'
import LoaderModal from '../../../../components/loaderModal';
import { InView } from "react-intersection-observer";

// Redux Selector / Action
import { useDispatch, useSelector } from 'react-redux';
import NoDataFound from '../../../../components/noDataFound';
import LetterDrawingComp from '../../../../components/gameComp/letterDrawingComp';
import { TapNumberGame } from '../../../../components/gameComp/TapNumberGame';
import { TapLetterGame } from '../../../../components/gameComp/TapLetterGame';
import { TraceLetterGame } from '../../../../components/gameComp/TraceLetterGame';
import { MatchCaseGame } from '../../../../components/gameComp/MatchcaseGame';
import { DragDropWordGame } from '../../../../components/gameComp/DragDropWordGame';
import { CountMatchGame } from '../../../../components/gameComp/CountMatchGame';
import { SimpleAdditionGame } from '../../../../components/gameComp/SimpleAdditionGame';
import { MatchDragLetter } from '../../../../components/gameComp/MatchDragLetter';
import { ColorShapePopGame } from '../../../../components/gameComp/ColorShapePopGame';
import { FruitBasketSortGame } from '../../../../components/gameComp/FruitBasketSortGame';
import { TapAnimalSoundGame } from '../../../../components/gameComp/TapAnimalSoundGame';
import { TapFruitColorGame } from '../../../../components/gameComp/TapFruitColorGame';
import { TapShapeGame } from '../../../../components/gameComp/TapShapeGame';

// const levels = Array.from({ length: 20 }, (_, i) => ({
//    id: i + 1,
//    unlocked: i < 1, // first 5 levels unlocked
//    stars: Math.floor(Math.random() * 4), // 0 to 3 stars
// }));

const levels = Array.from({ length: 20 }, (_, i) => ({
   id: i + 1,
   unlocked: i < 15, // First 5 levels unlocked
   stars: Math.floor(Math.random() * 4),
   // type: i < 12 ? 'letter' : 'number',
   game: (() => {
      if (i < 1) return 'tapLetter';
      if (i < 2) return 'tapLetterRandom';
      if (i < 3) return 'tapNumber';
      if (i < 4) return 'tapNumberRandom';
      if (i < 5) return 'countMatch';
      if (i < 6) return 'countMatchRandom';
      if (i < 7) return 'traceLetter';
      if (i < 8) return 'MatchDragLetter';
      if (i < 9) return 'matchCase';
      if (i < 10) return 'dragDropWord';
      if (i < 11) return 'ColorShapePopGame';
      if (i < 12) return 'TapFruitColorGame';
      if (i < 13) return 'FruitBasketSortGame';
      if (i < 14) return 'TapShapeGame';
      if (i < 15) return 'TapAnimalSoundGame';
      return 'simpleAddition';
   })()
}));

const LetterGame = () => {
   let profileData = (useSelector((state) => state.setting.setting.user_data))
   profileData = profileData ? JSON.parse(profileData) : "";
   const navigate = useNavigate();
   // const [showLoader, setShowLoader] = useState(false);
   const [currentLevel, setCurrentLevel] = useState(1);
   const [showLetterDrawingModal, setShowLetterDrawingModal] = useState(false);

   const handleLevelClick = (level) => {
      if (level.unlocked) {
         // alert(`Start Level ${level.id}`);
         setCurrentLevel(level.id)
         setShowLetterDrawingModal(true);
      }
   };

   const handleClose = () => {
      setShowLetterDrawingModal(false);
   }

   useEffect(() => {
   }, [])

   return (
      <>
         {/* <LoaderModal showLoader={showLoader} /> */}
         <div id='content-page' className='content-page'>
            <Container>
               <Row>
                  <Col sm="12">
                     <h4 className="card-title mb-3">Letter Game</h4>
                  </Col>
                  <Col sm="12">
                     <div className="level-grid">
                        {levels.map((level) => (
                           <div
                              key={level.id}
                              className={`level-box ${level.unlocked ? "unlocked" : "locked"}`}
                              onClick={() => handleLevelClick(level)}
                           >
                              <span>Level {level.id}</span>
                              {level.unlocked ? (
                                 <div className="stars">
                                    {"⭐".repeat(level.stars)}
                                 </div>
                              ) : (
                                 <div className="lock">🔒</div>
                              )}
                           </div>
                        ))}
                     </div>
                  </Col>
               </Row>
            </Container>

         </div>

         <Modal
            scrollable={true}
            show={showLetterDrawingModal}
            onHide={handleClose}
            size="xl"
            style={{
               marginTop: 50,
               marginBottom: 0,
               borderRadius: 36,
               padding: 0,
            }}
            className="custom-modal"
         >
            <Modal.Header className="d-flex justify-content-between align-items-center" style={{ border: "none", background: "none", padding: "24px 36px 0 36px" }}>
               <h4 className="modal-title" id="post-modalLabel" style={{ color: "#3e2723", fontWeight: 900, textShadow: "2px 2px 12px #fff, 0 0 12px #e0c68a", fontSize: 32, letterSpacing: 2 }}>
                  Level {currentLevel}
               </h4>
               <button type="button" className="btn btn-secondary lh-1" onClick={handleClose} style={{ background: "#ffe082", border: "none", color: "#3e2723", borderRadius: 16, fontWeight: 700, fontSize: 22, boxShadow: "0 2px 8px #e0c68a" }}>
                  <span className="material-symbols-outlined">close</span>
               </button>
            </Modal.Header>
            <Modal.Body style={{ overflowY: "auto", maxHeight: "75vh", width: "100%", padding: 0, display: "flex", justifyContent: "center" }}>
               <div className="modal-board-bg-kids">
                  {/* Game content inside board */}
                  {levels.find(l => l.id === currentLevel)?.game === 'tapLetter' && <TapLetterGame handleClose={handleClose} type="sequence" className="game-content" />}
                  {levels.find(l => l.id === currentLevel)?.game === 'tapLetterRandom' && <TapLetterGame handleClose={handleClose} type="random" className="game-content" />}
                  {levels.find(l => l.id === currentLevel)?.game === 'tapNumber' && <TapNumberGame handleClose={handleClose} type="sequence" className="game-content" />}
                  {levels.find(l => l.id === currentLevel)?.game === 'tapNumberRandom' && <TapNumberGame handleClose={handleClose} type="random" className="game-content" />}
                  {levels.find(l => l.id === currentLevel)?.game === 'countMatch' && <CountMatchGame handleClose={handleClose} type="sequence" className="game-content" />}
                  {levels.find(l => l.id === currentLevel)?.game === 'countMatchRandom' && <CountMatchGame handleClose={handleClose} type="random" className="game-content" />}
                  {levels.find(l => l.id === currentLevel)?.game === 'traceLetter' && <TraceLetterGame className="game-content" />}
                  {levels.find(l => l.id === currentLevel)?.game === 'MatchDragLetter' && <MatchDragLetter handleClose={handleClose} type="random" className="game-content" />}
                  {levels.find(l => l.id === currentLevel)?.game === 'matchCase' && <MatchCaseGame handleClose={handleClose} type="random" className="game-content" />}
                  {levels.find(l => l.id === currentLevel)?.game === 'dragDropWord' && <DragDropWordGame className="game-content" />}
                  {levels.find(l => l.id === currentLevel)?.game === 'ColorShapePopGame' && <ColorShapePopGame handleClose={handleClose} className="game-content" />}
                  {levels.find(l => l.id === currentLevel)?.game === 'TapFruitColorGame' && <TapFruitColorGame handleClose={handleClose} className="game-content" />}
                  {levels.find(l => l.id === currentLevel)?.game === 'FruitBasketSortGame' && <FruitBasketSortGame handleClose={handleClose} type="random" className="game-content" />}
                  {levels.find(l => l.id === currentLevel)?.game === 'TapAnimalSoundGame' && <TapAnimalSoundGame handleClose={handleClose} className="game-content" />}
                  {levels.find(l => l.id === currentLevel)?.game === 'TapShapeGame' && <TapShapeGame handleClose={handleClose} className="game-content" />}
                  {levels.find(l => l.id === currentLevel)?.game === 'simpleAddition' && <SimpleAdditionGame className="game-content" />}
                  {/* <LetterDrawingComp/> */}
               </div>
            </Modal.Body>
         </Modal>
         <style>
            {`
                .custom-modal .modal-dialog {
                  display: flex;
                  align-items: stretch !important;
                  justify-content: center;
                  margin: 32px auto 32px auto; /* 32px gap top and bottom */
                  width: auto;
                  max-width: 100vw;
                  min-height: 0;
                }
                .custom-modal .modal-content {
                  background-image: url('/image/back4.png');
                  background-size: 100% 100%;
                  background-position: center;
                  color: #222;
                  border-radius: 36px;
                  box-shadow: 0 12px 48px 0 #e0c68a55, 0 2px 16px #fff8e1;
                  border: 8px solid #ffe082;
                  min-height: 320px;
                  max-height: calc(100vh - 94px); /* 32px top + 32px bottom gap */
                  display: flex;
                  flex-direction: column;
                  max-width: 1000px;
                  width: 98vw;
                  overflow: hidden;
                  padding: 0;
                  margin-bottom: 0; /* handled by dialog margin */
                  animation: modal-pop 0.4s cubic-bezier(.68,-0.55,.27,1.55);
                }
                @keyframes modal-pop {
                  0% { transform: scale(0.8); opacity: 0; }
                  100% { transform: scale(1); opacity: 1; }
                }
                .custom-modal .modal-header,
                .custom-modal .modal-body {
                  background: none;
                  border: none;
                  box-shadow: none;
                  color: #222;
                  z-index: 2;
                }
                .custom-modal .modal-body {
                  flex: 1 1 auto;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: flex-start;
                  min-height: 200px;
                  padding: 0;
                  overflow-y: auto;
                  width: 100%;
                  max-height: 60vh; /* ensures scrolling inside modal body */
                }
                .modal-board-bg-kids {
                  background: url('/image/board.png');
                  background-size: contain;
                  background-repeat: no-repeat;
                  background-position: center;
                  border-radius: 32px;
                  box-shadow: 0 6px 32px #e0c68a33;
                  padding: 24px 8px 18px 8px;
                  margin: 16px auto;
                  max-width: 900px;
                  width: 98%;
                  min-height: 220px;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  position: relative;
                  z-index: 2;
                  animation: board-pop 0.5s cubic-bezier(.68,-0.55,.27,1.55);
                }
                @keyframes board-pop {
                  0% { transform: scale(0.9); opacity: 0; }
                  100% { transform: scale(1); opacity: 1; }
                }
                .modal-board-bg-kids h4,
                .modal-board-bg-kids .game-content {
                  color: #3e2723;
                  text-shadow: 2px 2px 12px #fff, 0 0 12px #e0c68a;
                  font-weight: 900;
                }
                /* Desktop (default) */
                @media (max-width: 1200px) {
                  .custom-modal .modal-content {
                    max-width: 98vw;
                  }
                  .modal-board-bg-kids {
                    max-width: 98vw;
                  }
                }
                /* Tablet */
                @media (max-width: 900px) {
                  .custom-modal .modal-dialog {
                    margin: 16px auto 16px auto;
                  }
                  .custom-modal .modal-content {
                    border-radius: 24px;
                    max-height: calc(100vh - 32px);
                  }
                }
                /* Mobile */
                @media (max-width: 700px) {
                  .custom-modal .modal-dialog {
                    margin: 8px auto 8px auto;
                    min-height: 100vh;
                  }
                  .custom-modal .modal-content {
                    min-height: 120px;
                    max-height: calc(100vh - 16px);
                    border-radius: 14px;
                  }
                }
                @media (max-width: 480px) {
                  .custom-modal .modal-content {
                    border-width: 4px;
                  }
                  .modal-board-bg-kids {
                    padding: 4px 0vw;
                  }
                }
            `}
         </style>
      </>

   )
}

export default LetterGame